import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer/product/number'

const initialState = () => ({
    products: {
        data: [],
        pagination: {}
    },
    technologies: {
        data: []
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        products: state => state.products.data,
        pagination: state => state.products.pagination,
        technologies: state => state.technologies.data,
    },
    actions: {
        /**
         * @param {{customerId: number, params: {}}} data
         * @returns {Promise<*>}
         */
        listToolboxProducts: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listToolboxProducts(data)
                const products = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_TOOLBOX_PRODUCTS, products)
                return products
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{customerId: number, serviceNumber: string, params: {}}} params
         * @returns {Promise<*>}
        */
        listTechnologies: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listTechnologies(params)
                const technologies = {
                    ...response
                }
                commit(mutationTypes.SET_TECHNOLOGIES, technologies)

                return technologies
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
         /**
         * @param {{customerId: number, serviceNumber: string, params: {}}} data
         * @returns {Promise<*>}
         */
        enableTechnology: async ({dispatch}, data) => {
            try {
                return await api.enableTechnology(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
         /**
         * @param {{customerId: number, serviceNumber: string, params: {}}} data
         * @returns {Promise<*>}
         */
        disableTechnology: async ({dispatch}, data) => {
            try {
                return await api.disableTechnology(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetToolboxProducts: ({commit}) => commit(mutationTypes.RESET_TOOLBOX_PRODUCTS),
        resetTechnologies: ({commit}) => commit(mutationTypes.RESET_TECHNOLOGIES)
    },
    mutations: {
        [mutationTypes.RESET_TOOLBOX_PRODUCTS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_TOOLBOX_PRODUCTS]: (state, data) => state.products = data,
        [mutationTypes.SET_TECHNOLOGIES]: (state, data) => state.technologies = data,
        [mutationTypes.RESET_TECHNOLOGIES]: (state) => Object.assign(state, initialState()),
    }
}
